module.exports = __webpack_public_path__ + "media/GOOVER.41f0ff35.mp4";